"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonPageTDK = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const head_1 = require("../head");
class CommonPageTDK extends react_1.Component {
    constructor() {
        super(...arguments);
        this.BaseContent = () => {
            return ((0, jsx_runtime_1.jsxs)(head_1.DynamicHead, { children: [(0, jsx_runtime_1.jsx)("title", { children: this.props.title }), (0, jsx_runtime_1.jsx)("meta", { name: "description", content: this.props.description }), (0, jsx_runtime_1.jsx)("meta", { name: "keywords", content: Array.isArray(this.props.keywords) ? this.props.keywords.join(',') : this.props.keywords })] }));
        };
    }
    render() {
        const { BaseContent, CanonicalLink } = this;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(BaseContent, {}), (0, jsx_runtime_1.jsx)(CanonicalLink, {})] }));
    }
}
exports.CommonPageTDK = CommonPageTDK;
